// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DescriptionsTokens } from './type';

const descriptionsTokens: DescriptionsTokens = {
  descriptionsTitlePaddingBottom: 'Spacing-12',
  descriptionsTitleSmallFontSize: 'Font-14',
  descriptionsTitleDefaultFontSize: 'Font-16',
  descriptionsTitleLargeFontSize: 'Font-18',
  descriptionsTitleColor: 'Neutral-text-5',
  descriptionsTitleFontWeight: 'Weight-medium',
  descriptionsTitleGap: 'Size-2',
  descriptionsLabelPaddingBottom: 'Spacing-12',
  descriptionsLabelPaddingRight: 'Spacing-8',
  descriptionsLabelColor: 'Neutral-text-4',
  descriptionsValuePaddingBottom: 'Spacing-12',
  descriptionsValueColor: 'Neutral-text-5',
  descriptionsBorderDefaultSize: 'Border-1',
  descriptionsBorderColor: 'Neutral-border-1',
  descriptionsBorderRadius: 'Radius-lesser',
  descriptionsBorderRightSize: '1px',
  descriptionsBorderBottomSize: '1px',
  descriptionsBorderPaddingX: 'Spacing-12',
  descriptionsBorderPaddingY: 'Spacing-8',
  descriptionsDefaultFontSize: 'Font-14',
  descriptionsSmallFontSize: 'Font-12',
  descriptionsLargeFontSize: 'Font-16',
  descriptionsBackgroundColor: 'Neutral-fill-2',
  descriptionsCellGap: 'Spacing-0',
  descriptionsInlineBorderPaddingX: 'Spacing-8',
  descriptionsInlineBorderPaddingY: 'Spacing-12',
  descriptionsVerticalPaddingBottom: 'Spacing-2',
};

export default descriptionsTokens;
